import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { TpostSchema, postSchema } from "../../lib/types"
import ImageInput from "../../components/ImageInput"
import { useDispatch } from "react-redux"
import { addPost } from "./postsSlice"
import { useNavigate } from "react-router-dom"
import { v4 as uuidv4 } from "uuid"

function NewPost() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: {
      errors,
      isSubmitting,
      isDirty,
      isValid,
    },
  } = useForm<TpostSchema>({
    mode: "onChange",
    resolver: zodResolver(postSchema),
  })

  const onSubmit = async (data: TpostSchema) => {
    const newPost = {
      ...data,
      id: uuidv4(),
      picture: "", // ImageInput handling would go here, for now placeholder
      createdAt: new Date().toISOString(),
    }
    dispatch(addPost(newPost as any))
    navigate("/dashboard/posts")
  }

  return (
    <section className="contr">
      <h1 className="text-2xl font-bold mb-6">Add New Post</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <ImageInput
          name="picture"
          register={register}
          errors={errors.picture}
          isDirty={isDirty}
          isValid={isValid}
        />
        
        <div className="flex flex-col md:flex-row gap-4">
          <label className="md:w-1/4 text-[#dbd7df] text-lg capitalize">title</label>
          <div className="md:w-3/4">
            <input
              className={`input w-full ${errors.title ? "border-red-500" : "border-[#39353B] focus:border-[#6b69f2]"}`}
              {...register("title")}
              placeholder="Add your own title"
            />
            {errors.title && (
              <p className="mt-1 text-red-500 text-sm">
                {errors.title?.message}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <label className="md:w-1/4 text-[#dbd7df] text-lg capitalize">description</label>
          <div className="md:w-3/4">
            <textarea
              className={`input w-full h-32 ${errors.describtion ? "border-red-500" : "border-[#39353B] focus:border-[#6b69f2]"}`}
              placeholder="Add your own description"
              {...register("describtion")}
            ></textarea>

            {errors.describtion && (
              <p className="mt-1 text-red-500 text-sm">
                {errors.describtion.message}
              </p>
            )}
          </div>
        </div>

        <div className="button-container border-t border-[#39353B] pt-6 flex justify-end">
          <button disabled={isSubmitting} type="submit" className="btn px-8">
            {isSubmitting ? "Saving..." : "Save Post"}
          </button>
        </div>
      </form>
    </section>
  )
}

export default NewPost
